import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./StatTile.module.scss";
export const StatTile = ({ value, unit, label, inline = false, className, ...rest }) => {
    return (_jsxs("div", { className: cn(styles.tile, inline && styles.inline, className), ...rest, children: [_jsxs("div", { className: styles.value, children: [value, unit && _jsx("span", { className: styles.unit, children: unit })] }), _jsx("div", { className: styles.label, children: label })] }));
};
